import React from 'react';
import {useLocation} from 'react-router-dom';
import styles from './footer.module.scss';
import FooterItem from './item';

const menus: Array<IMenu> = [
  {
    title: 'فروشندگان',
    icon: 'icon-store',
    activeIcon: 'icon-store-active',
    route: '/home',
  },
  {
    title: 'خریداران',
    icon: 'icon-buyer',
    activeIcon: 'icon-buyer-active',
    route: '/buyer',
  },
  {
    title: 'ثبت آگهی',
    icon: '',
    route: '/post/add/inputGroup',
    isMain: true,
  },
  {
    title: 'پیام‌ها',
    icon: 'icon-chat',
    activeIcon: 'icon-chat-active',
    route: '/message',
  },
  {
    title: 'حساب من',
    icon: 'icon-Vector',
    activeIcon: 'icon-profile-active',
    route: '/profile',
  },
];
const Footer = () => {
  const {pathname} = useLocation();
  return (
    <>
      <div className={styles.footer}>
        <div className="d-flex justify-content-around align-items-center h-100">
          {React.Children.toArray(
            menus.map(item => (
              <>
                <FooterItem
                  isMain={item?.isMain}
                  title={item?.title}
                  icon={
                    pathname.includes(item.route.replace(/\//g, ''))
                      ? item?.activeIcon
                      : item?.icon
                  }
                  router={item?.route}
                  isActive={pathname.includes(item.route.replace(/\//g, ''))}
                />
              </>
            )),
          )}
        </div>
      </div>
    </>
  );
};

export default Footer;
